import apiRequest from './api_request';
import {ref, watch} from "vue";
import {API_BASE_URL} from "../config";
import {dateRange} from "../composables/getFinancial";

type FinancialDataItem = {
    id: number;
    totalRevenue: number;
    totalExpenses: number;
    profitTotal: number;
    profitReport: number;
    reportExpenses: number;
    carCost: number;
    overHeadCost: number;
    personnelCost: number;
    otherCost: number;
    reportDate: string; // ISO date string (e.g. "2024-10-01")
    createdAt: string; // ISO timestamp string (e.g. "2025-05-21T14:55:42.000Z")
};

type CardItem = {
    title: string,
    totalKm: number,
    costPrev: number,
    costLatest: number,
    revenuePrev: number,
    revenueLatest: number,
    changeCost: number,
    changeRevenue: number,
    changeProfit: number,
    profitLatest: number,
    profitPrev: number,
};

export type FinancialResponse = {
    financialData: FinancialDataItem[];
    cards: CardItem[];
    totalRows: number;
};
export let financialResponse = ref({
    financialData: [],
    cards: [],
    totalRows: 0,
} as FinancialResponse);
export const dateRange = ref(new Date());
watch(dateRange, (value) => {
    console.log("dateRange changed", value);
    let newDate = new Date(value)
    if (isNaN(newDate.getTime())) {
        dateRange.value = new Date(value.year, value.month);
    } else {
        getFinancialData().then((data) => {
            console.log("received data from change date")
        });
    }
});
const dateFormatter = (date: any): string => {
    if (date != null) {
        const options = {year: 'numeric', month: '2-digit', day: '2-digit'};
        return new Date(date).toLocaleDateString('en-CA', options).replace(/-/g, '/');
    } else {
        return '';
    }
}

export const getFinancialData = async () => {
    try {
        const url = `${API_BASE_URL}/api/excel/financial?date=` + dateFormatter(dateRange.value);
        const options = {
            method: 'GET',
            headers: {
                'accept': 'application/json',
            },
            params: {
                date: dateFormatter(dateRange.value),
            },
        };
        let data = await apiRequest(url, options);
        if (data) {
            financialResponse.value = data;
        } else {
            console.error('No data received from API');
        }
        return data;
    } catch (error) {
        console.error('Error fetching financial data:', error);
        throw error;
    }
};